// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5800":"css/app.6945","8069":"css/admin-app.6945"}[chunkId] + ".css";
};